interface Props extends React.SVGProps<SVGSVGElement> {
  readonly size?: number;
}

export default function RoundedTriangleIcon(props: Props) {
  const { size = 8, ...rest } = props;

  return (
    <svg
      width={size}
      viewBox="0 0 8 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        d="M3.168 4.751 1.036 1.553A1 1 0 0 1 1.868 0h4.264a1 1 0 0 1 .832 1.554L4.832 4.751a1 1 0 0 1-1.664 0Z"
        fill="currentColor"
      />
    </svg>
  );
}
